/* BP Motors · página de vehículos: cabecera, galería en arco, aparición al hacer scroll, filtros y orden */
(function () {
  'use strict';
  var root = document.getElementById('gx');
  if (!root) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Cabecera ---------- */
  var burger = $('#burger'), mnav = $('#mnav'), top = $('.top');
  function setMenu(open) {
    mnav.hidden = !open;
    burger.setAttribute('aria-expanded', open);
    burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  burger.addEventListener('click', function () { setMenu(mnav.hidden); });
  mnav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mnav.hidden) { setMenu(false); burger.focus(); } });
  var lastY = 0;
  addEventListener('scroll', function () {
    var y = scrollY;
    top.classList.toggle('hide', y > lastY + 2 && y > 180 && mnav.hidden);
    if (y < lastY - 2 || y <= 180) top.classList.remove('hide');
    lastY = y;
  }, { passive: true });
  var nav = $('#nav'), ind = $('.ind', nav), cur = $('a[aria-current]', nav);
  function moveInd() {
    if (!cur || !ind) return;
    var r = cur.getBoundingClientRect(), n = nav.getBoundingClientRect();
    ind.style.width = r.width + 'px';
    ind.style.transform = 'translateX(' + (r.left - n.left) + 'px)';
    ind.style.opacity = 1;
  }
  moveInd();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveInd);
  addEventListener('resize', moveInd);

  /* ---------- Aparición al hacer scroll ---------- */
  var rv = $$('.gx-rv');
  function show(n) { n.classList.add('in'); }
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    rv.forEach(function (n) { io.observe(n); });
    setTimeout(function () { rv.forEach(show); }, 8000);
  } else {
    rv.forEach(show);
  }

  /* ---------- Galería en arco ---------- */
  var slides = $$('.gx-slide'), dots = $$('.gx-dots button'), arch = $('#gx-arch');
  var romans = ['I', 'II', 'III', 'IV', 'V', 'VI'];
  var capn = $('#gx-capn'), capt = $('#gx-capt'), capp = $('#gx-capp'), capl = $('#gx-capl');
  var idx = 0, timer = 0, hover = false;
  function go(i) {
    if (!slides.length) return;
    idx = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) {
      var on = k === idx;
      if (on && !s.classList.contains('on')) { var im = $('img', s); if (im) { im.style.animation = 'none'; void im.offsetWidth; im.style.animation = ''; } }
      s.classList.toggle('on', on);
      s.tabIndex = on ? 0 : -1;
    });
    dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === idx); });
    var s = slides[idx];
    if (capn) capn.textContent = romans[idx];
    if (capt) capt.textContent = s.dataset.t;
    if (capp) capp.textContent = s.dataset.p + ' €';
    if (capl) capl.href = s.href;
  }
  function play() {
    clearInterval(timer);
    if (reduce || slides.length < 2) return;
    timer = setInterval(function () { if (!hover && !document.hidden) go(idx + 1); }, 6500);
  }
  if (slides.length) {
    go(0);
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    if (arch) {
      arch.addEventListener('pointerenter', function () { hover = true; });
      arch.addEventListener('pointerleave', function () { hover = false; });
    }
    play();
  }

  /* ---------- Filtros y orden (con transición) ---------- */
  var grid = $('#gx-grid'), chips = $$('.gx-chip'), sort = $('#gx-sort');
  if (!grid) return;
  var cards = $$('.vc', grid), filter = 'all';
  function apply() {
    var list = cards.filter(function (c) { return filter === 'all' || c.dataset.type === filter; });
    var key = sort ? sort.value : 'order';
    list.sort(function (a, b) {
      if (key === 'asc') return a.dataset.price - b.dataset.price;
      if (key === 'desc') return b.dataset.price - a.dataset.price;
      return a.dataset.order - b.dataset.order;
    });
    cards.forEach(function (c) { c.hidden = list.indexOf(c) < 0; });
    list.forEach(function (c) { grid.appendChild(c); c.classList.add('in'); });
    if (!reduce) { grid.classList.remove('swap'); void grid.offsetWidth; grid.classList.add('swap'); }
  }
  chips.forEach(function (b) {
    b.addEventListener('click', function () {
      filter = b.dataset.f;
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      apply();
    });
  });
  if (sort) sort.addEventListener('change', apply);
})();